import { type Address, getAddress } from 'viem'
import type { VaultId } from '../types/VaultId'
import { isAddress } from './isAddress'

export type { VaultId } from '../types/VaultId'

export const VAULT_ADDRESS_LENGTH = 42

export function toVaultId(address: string, uniqueDescriptor?: string): VaultId {
  const normalizedAddress = getAddress(address)
  return (!uniqueDescriptor ? normalizedAddress : `${normalizedAddress}-${uniqueDescriptor}`) as VaultId
}

export function fromVaultId(vaultId: string): { address: Address; uniqueDescriptor: string } {
  const [address, ...uniqueDescriptorParts] = vaultId.split('-')
  const uniqueDescriptor = uniqueDescriptorParts.join('-')

  if (!isAddress(address) || (uniqueDescriptorParts.length > 0 && uniqueDescriptor === '')) {
    throw new Error(`Invalid vault id: ${vaultId}`)
  }

  return {
    address: getAddress(address),
    uniqueDescriptor,
  }
}
